import { useTranslation } from 'react-i18next';
import EntityModal from './EntityModal';

interface ConfirmDialogProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  title: string;
  message: string;
  confirmLabel?: string;
  isLoading?: boolean;
}

const ConfirmDialog = ({
  isOpen,
  onConfirm,
  onCancel,
  title,
  message,
  confirmLabel,
  isLoading = false,
}: ConfirmDialogProps) => {
  const { t } = useTranslation();

  const footer = (
    <>
      <button className="management-btn management-btn--secondary" onClick={onCancel}>
        {t('management.cancel')}
      </button>
      <button
        className="management-btn management-btn--danger"
        onClick={onConfirm}
        disabled={isLoading}
      >
        {isLoading ? t('management.deleting') : (confirmLabel ?? t('management.delete'))}
      </button>
    </>
  );

  return (
    <EntityModal isOpen={isOpen} onClose={onCancel} title={title} footer={footer} width="420px">
      <p className="confirm-dialog-message">{message}</p>
    </EntityModal>
  );
};

export default ConfirmDialog;
